import { enviroment } from "../../enviroment";
import { getActAsOrgId } from "../../contexts/actAsStore";

// Flag REACT_APP_ADMIN_VERDICT_ORG_ID_ENABLED (hotfix 02/11-2026, Nichlas:
// «kan vi lave hotfix på denne og sørge at det ikke sker igen»): the query
// string the three verdict calls - PUT organizations/{orgId}/logos/{id}/
// approval, .../designs/{id}/approval and .../orders/{id}/approval - append
// to their URL.
//
// What the API does with it (js-kitmaker-api LogoFunctions.LogoApproval,
// DesignFunctions.DesignApproval, OrderFunctions.OrderApproval): for an Admin
// caller the QUERY parameter orgId is REQUIRED («User of kind 'Admin' must
// set orgId to perform action» - a 400, for orders a 500 - which the admin UI
// showed as «Could not update approval: …» on every Approve/Reject) and it is
// the ACTING organization: Verdict.OrganizationId = that org, and
// DefaultApprovalService.PlaceVerdictAsync writes the verdict into the
// Customer or the Vendor approval slot by that org's TYPE. For a customer or
// vendor the API never reads the parameter (their organization comes from the
// caller's B2C id).
//
// So the value is the organization the admin ACTS AS - the act-as vendor
// (contexts/actAsStore) - never the path's org: the path names the logo's /
// design's / order's owner (normally the customer), and that value would make
// an act-as-vendor Approve land in the CUSTOMER slot with a 200. An admin
// reaches Approve/Reject only while acting as a vendor (approval-voting.tsx
// hides the buttons for Role.Admin), hence:
//   flag on + act-as vendor X -> "?orgId=X" (the vendor's slot, as a real
//                                vendor's own call reaches it)
//   flag on, no act-as        -> "" (customers, vendors and a plain admin
//                                keep today's byte-identical URL; a plain
//                                admin's call fails as today instead of
//                                writing into a slot nobody chose)
//   flag off                  -> "" (byte-identical URL)
// Never "?orgId=0" or another unusable value: an unknown org is a 500 in the
// API, not a 400. The source pin ApiClient.verdictOrgIdPin.test.ts makes
// every verdict route use this helper and nothing else.
export function verdictOrgIdQuery(): string {
  if (!enviroment.adminVerdictOrgIdEnabled) return "";
  const actAsOrgId = getActAsOrgId();
  if (actAsOrgId === undefined || !Number.isInteger(actAsOrgId) || actAsOrgId <= 0) return "";
  return `?orgId=${actAsOrgId}`;
}
